<template>
  <v-menu bottom left offset-y content-class="theme-menu">
    <!-- <template v-slot:activator="{ on, attrs }">
      <div id="app-bar-notification-center-trigger">
        <color-marker id="unread-marker" v-if="unreadCount > 0" color="green" />
        <v-btn icon v-bind="attrs" v-on="on">
          <v-icon class="material-icons-outlined text color-black-alt-lighten-1"
            >notifications</v-icon
          >
        </v-btn>
      </div>
    </template> -->

    <v-list>
      <v-list-item
        v-for="(notif, index) in notifications"
        :key="index"
        class="notification-item"
        :class="{ unread: !notif.read }"
      >
        <v-list-item-icon>
          <v-icon class="material-icons-outlined">{{ notif.icon }}</v-icon>
        </v-list-item-icon>
        <v-list-item-title>{{ notif.label }}</v-list-item-title>
      </v-list-item>
    </v-list>
  </v-menu>
</template>

<script type="text/javascript">
import colorMarker from "@/components/ui/color-marker";

export default {
  name: "app-bar-notification-center-trigger",
  components: {
    colorMarker,
  },
  data() {
    return {};
  },
  computed: {
    notifications() {
      return this.$store.state.notifications.map((item) => {
        item.icon = item.type === "settings" ? "settings" : "notifications";
        return item;
      });
    },
    unreadCount() {
      let count = 0;
      this.notifications.forEach((notif) => {
        count += !notif.read ? 1 : 0;
      });
      return count;
    },
  },
  created() {},
  methods: {},
};
</script>

<style lang="scss">
#app-bar-notification-center-trigger {
  display: inline-block;
  border: 1px solid $purple-lighten-4;
  border-radius: 50%;
  height: 40px;
  width: 40px;
  text-align: center;
  position: relative;
  button {
    height: 38px;
    width: 38px;
  }

  #unread-marker {
    position: absolute;
    top: -2px;
    right: -1px;
  }
}

.theme-menu {
  .notification-item {
    &.unread {
      background-color: $purple-lighten-4-3;
      .v-list-item__icon {
        i {
          color: $black-lighten-1 !important;
        }
      }
      .v-list-item__title {
        color: $black-lighten-1 !important;
      }
    }
  }
}
</style>